<template>
    <div id="app">

        <header id="nav">
            <div class="ausrichtung">
                <div style="display: flex;align-items: center;">
                    <router-link to="/" style="flex: 1;  ">
                        <img src="./assets/logo.png" alt="Logo VRB Niederschlesien" style="max-width: 100%">
                    </router-link>

                    <a href="tel:+49 3581 46460" class="icons">
                        <svg width="40" height="40" viewBox="0 0 40 40">
                            <path d="M30.09 3c.59.05 5.56.63 6.89 5.42-.32 1-2.59 3.3-4.69 4.46-.77.43-1.24.55-1.48.59-.08-.1-.18-.21-.29-.35-1.62-1.97-2.49-2.87-3.21-3.34 0 0-.58-.51-1.93-.47-2.15.07-5.23 2.59-9.23 6.56l-.14.13-.14.14c-3.99 4.02-6.52 7.18-6.55 9.27-.02 1.1.42 1.8.42 1.8.36.6 1.06 1.44 3.67 3.51.08.06.15.12.2.16 0 .28-.18 1.08-1.04 2.36-.44.65-1.09 1.43-1.74 2.08-1.11 1.11-1.88 1.53-2.17 1.64-4.45-2.07-5.5-6.21-5.66-6.98.11-3.73 5.57-12.27 10.09-16.8l.04-.04C17.68 8.59 26.37 3.05 30.09 3m.04-3c-5.02 0-14.5 6.4-19.12 11C6.38 15.63-.05 25.15 0 30.15l.01.17c.04.27 1.12 6.64 7.7 9.51.27.12.56.17.85.17 1.4 0 3.04-1.2 4.39-2.54.88-.88 1.63-1.82 2.11-2.53 1.78-2.64 2.04-4.81.74-6.11-.13-.13-.31-.27-.53-.45-2.15-1.7-2.78-2.41-2.95-2.69.16-1.88 4.12-5.82 5.83-7.55 1.71-1.69 5.64-5.63 7.53-5.82.61.39 2.04 2.14 2.53 2.73.3.37.53.64.64.75.38.38.96.71 1.82.71.77 0 1.77-.26 3.07-.98 2.56-1.42 6.82-5.18 6.2-7.62C38.46 2 32.95.16 30.19.01 30.17 0 30.15 0 30.13 0z"></path>
                        </svg>
                        <span>03581 464-60</span>
                    </a>
                    <a class="icons" target="_blank"
                       href="https://www.vrb-niederschlesien.de/service/formular-center-allgemein/formular-e-mail-kontakt-marginalspalte.html?contactRes=/bausteine/kontakte/kontaktbausteine/jcr:content/parsys/kontaktbaustein/kontakt">
                        <svg width="40" height="40" viewBox="0 0 40 40">
                            <path d="M24.6 25.2h-.1C23.2 29 20.9 31 17.3 31c-2.1.1-4.1-.8-5.5-2.5-1.5-1.9-2.2-4.2-2.1-6.6-.1-3.3.9-6.5 2.9-9.1 1.7-2.3 4.5-3.7 7.5-3.6 1.1 0 2.2.3 3.2.9.9.5 1.5 1.3 1.8 2.3h.1c0-.5.1-1.4.2-2.8h3.1c-.8 8.9-1.2 13.5-1.2 13.7 0 3.4 1 5 2.9 5 1.8 0 3.3-.9 4.4-2.8 1.3-2.3 1.9-4.8 1.8-7.4.2-4.1-1.4-8-4.3-10.9C29.2 4.4 25.3 3 20.2 3c-4.6-.1-9 1.7-12.1 5.1-3.2 3.4-5 8-4.8 12.7 0 5 1.5 9 4.6 12.1s7.1 4.6 12.3 4.6c3.6.1 7.2-.6 10.4-2v3c-3.4 1.3-7 1.9-10.7 1.8-6 0-10.8-1.8-14.5-5.3C1.8 31.1 0 26.4 0 20.7-.2 15.2 1.9 9.9 5.8 5.9 9.6 2 15-.2 20.5 0c5.1-.2 10.1 1.6 13.9 4.9 3.7 3.3 5.7 8 5.5 12.8.1 3.4-.9 6.7-2.9 9.5-1.5 2.4-4.2 3.8-7 3.8-3.6 0-5.4-2-5.4-5.8zm-4.5-13.3c-2.1 0-4 1.1-5 2.9-1.3 2.1-2 4.6-1.9 7.1-.1 1.6.4 3.2 1.3 4.5.8 1.1 2.1 1.7 3.4 1.7 2.1 0 4-1.2 4.9-3 1.3-2.5 1.9-5.2 1.8-8 0-3.4-1.5-5.2-4.5-5.2z"></path>
                        </svg>
                        <span>Schreiben Sie uns</span>
                    </a>
                    <a class="icons" target="_blank"
                       href="https://www.vrb-niederschlesien.de/service/formular-center-allgemein/allgemeines-kontaktformular.html?contactRes=/bausteine/kontakte/kontaktbausteine/jcr:content/parsys/kontaktbaustein/kontakt">
                        <svg width="40" height="40" viewBox="0 0 40 40">
                            <path d="M31 21H20V8.25a1.5 1.5 0 00-3 0V22a2.179 2.179 0 002 2h12c1.736 0 1.625-3 0-3z"></path>
                            <path d="M20 3c9.374 0 17 7.626 17 17s-7.626 17-17 17S3 29.374 3 20 10.626 3 20 3m0-3C8.954 0 0 8.954 0 20s8.954 20 20 20 20-8.954 20-20S31.046 0 20 0z"></path>
                        </svg>
                        <span>Terminvereinbarung</span>
                    </a>
                </div>
            </div>
        </header>
        <div class="imageheader">
            <img src="./assets/Teaser_Claim_RGB.jpg" alt="Männer" style="max-width: 100%">
        </div>
        <div class="content ausrichtung">
            <transition name="fade" mode="out-in">
                <router-view/>
            </transition>
        </div>
        <footer>
            <div class="ausrichtung">
                <a href="https://www.vrb-niederschlesien.de/service/rechtliche-hinweise/impressum.html" target="_blank">Impressum</a>
                <router-link to="/ds">Datenschutz</router-link>
            </div>
        </footer>
    </div>
</template>

<style lang="scss">
    @import "./assets/normalize.css";
    @import "./assets/default.scss";

</style>
<style lang="scss" scoped>
    .icons {
        line-height: 20px;
        align-items: center;
        display: flex;

        svg {
            width: 20px;
            height: 20px;
            fill: #0066b3;
            margin-right: 6px;
            margin-left: 24px;
            @media only screen and (max-width: 840px) {
                width: 16px;
                height: 16px;
                margin-left: 20px;
            }
            @media only screen and (max-width: 720px) {
                margin-right: 0;
            }
        }

        span {
            font-weight: bold;
            @media only screen and (max-width: 840px) {
                font-size: 14px;
                font-weight: normal;
            }
            @media only screen and (max-width: 720px) {
                display: none;
            }
        }
    }

    .content {
        padding: 20px;
        margin-bottom: 40px;
    }


    .fade-enter-active,
    .fade-leave-active {
        transition-duration: 0.3s;
        transition-property: opacity;
        transition-timing-function: ease;
    }

    .fade-enter,
    .fade-leave-active {
        opacity: 0
    }

    button {
        padding: 15px;
        border: 1px solid #268fdd;
        font-size: 18px;
        margin: 15px;
    }


</style>
<script type="text/babel">


    export default {
        name: 'home',

        computed: {

            loading() {

                return this.$root.loading
            }
        },
    }
</script>
